import { useTranslations } from "@/lib/i18n/intl";
import { keys } from "@/lib/i18n/portal";
import type { StorePolicyView } from "@/lib/api/types";
import { PoliciesForm } from "@/modules/settings/components/PoliciesForm";
import { Card } from "./primitives";

type PoliciesPanelProps = {
  storeSlug: string;
  policies: StorePolicyView[];
};

export function PoliciesPanel({ storeSlug, policies }: PoliciesPanelProps) {
  const t = useTranslations();
  const ss = keys.seller.storeSettings;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 16 }}>
      <Card title={t(ss.policiesTitle)} desc={t(ss.policiesDesc)}>
        <PoliciesForm storeSlug={storeSlug} initialPolicies={policies} />
      </Card>
    </div>
  );
}
